import EventHandler from '../../utils/dom/event-handler';
import SelectorEngine from '../../utils/dom/selector-engine';

class CourseDetailsLtaPlay {
	constructor() {
		const wrapperComponent = SelectorEngine.findOne('.js-course-booking');
		if (wrapperComponent) {
			this.init();
		}
	}

	init() {
		this.checkboxes = document.getElementsByName('courseSessionTimes');

		for (const checkbox of this.checkboxes) {
			EventHandler.on(checkbox, 'change', (event) => {
				// this.checkboxHandler(event);
			});
		}
	}

	checkboxHandler(event) {
		const { value } = event.target;

		// If the last checkbox is checked, uncheck all other checkboxes
		if (value === 'register_for_the_event' && event.target.checked) {
			this.checkboxes.forEach((checkbox) => {
				if (checkbox.value !== 'register_for_the_event' && checkbox.checked) {
					checkbox.checked = false;
				}
			});
		} // and vise a versa
		else if (value !== 'register_for_the_event' && event.target.checked) {
			this.checkboxes.forEach((checkbox) => {
				if (checkbox.value === 'register_for_the_event' && checkbox.checked) {
					checkbox.checked = false;
				}
			});
		}
	}
}

const globalCourseDetailsLtaPlay = new CourseDetailsLtaPlay();

export default globalCourseDetailsLtaPlay;
